export default "/bundles/assets/scroll-down_7aad14233fa37620d00c981e3ecaa5f3.png";